/*! For license information please see sections.gmv-pdp-rhude.js.LICENSE.txt */
(() => {
  function t(e) {
    return (
      (t =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
              return typeof t;
            }
          : function (t) {
              return t &&
                "function" == typeof Symbol &&
                t.constructor === Symbol &&
                t !== Symbol.prototype
                ? "symbol"
                : typeof t;
            }),
      t(e)
    );
  }

  function e() {
    var t,
      i,
      r = "function" == typeof Symbol ? Symbol : {},
      o = r.iterator || "@@iterator",
      a = r.toStringTag || "@@toStringTag";

    function u(e, r, o, a) {
      var u = r && r.prototype instanceof l ? r : l,
        d = Object.create(u.prototype);
      return (
        n(
          d,
          "_invoke",
          (function (e, n, r) {
            var o,
              a,
              u,
              l = 0,
              d = r || [],
              c = !1,
              h = {
                p: 0,
                n: 0,
                v: t,
                a: y,
                f: y.bind(t, 4),
                d: function (e, n) {
                  return ((o = e), (a = 0), (u = t), (h.n = n), s);
                },
              };

            function y(e, n) {
              for (a = e, u = n, i = 0; !c && l && !r && i < d.length; i++) {
                var r,
                  o = d[i],
                  y = h.p,
                  f = o[2];
                e > 3
                  ? (r = f === n) &&
                    ((u = o[(a = o[4]) ? 5 : ((a = 3), 3)]), (o[4] = o[5] = t))
                  : o[0] <= y &&
                    ((r = e < 2 && y < o[1])
                      ? ((a = 0), (h.v = n), (h.n = o[1]))
                      : y < f &&
                        (r = e < 3 || o[0] > n || n > f) &&
                        ((o[4] = e), (o[5] = n), (h.n = f), (a = 0)));
              }
              if (r || e > 1) return s;
              throw ((c = !0), n);
            }
            return function (r, d, f) {
              if (l > 1) throw TypeError("Generator is already running");
              for (
                c && 1 === d && y(d, f), a = d, u = f;
                (i = a < 2 ? t : u) || !c;
              ) {
                o ||
                  (a
                    ? a < 3
                      ? (a > 1 && (h.n = -1), y(a, u))
                      : (h.n = u)
                    : (h.v = u));
                try {
                  if (((l = 2), o)) {
                    if ((a || (r = "next"), (i = o[r]))) {
                      if (!(i = i.call(o, u)))
                        throw TypeError("iterator result is not an object");
                      if (!i.done) return i;
                      ((u = i.value), a < 2 && (a = 0));
                    } else
                      (1 === a && (i = o.return) && i.call(o),
                        a < 2 &&
                          ((u = TypeError(
                            "The iterator does not provide a '" +
                              r +
                              "' method",
                          )),
                          (a = 1)));
                    o = t;
                  } else if ((i = (c = h.n < 0) ? u : e.call(n, h)) !== s)
                    break;
                } catch (e) {
                  ((o = t), (a = 1), (u = e));
                } finally {
                  l = 1;
                }
              }
              return {
                value: i,
                done: c,
              };
            };
          })(e, o, a),
          !0,
        ),
        d
      );
    }
    var s = {};

    function l() {}

    function d() {}

    function c() {}
    i = Object.getPrototypeOf;
    var h = [][o]
        ? i(i([][o]()))
        : (n((i = {}), o, function () {
            return this;
          }),
          i),
      y = (c.prototype = l.prototype = Object.create(h));

    function f(t) {
      return (
        Object.setPrototypeOf
          ? Object.setPrototypeOf(t, c)
          : ((t.__proto__ = c), n(t, a, "GeneratorFunction")),
        (t.prototype = Object.create(y)),
        t
      );
    }
    return (
      (d.prototype = c),
      n(y, "constructor", c),
      n(c, "constructor", d),
      (d.displayName = "GeneratorFunction"),
      n(c, a, "GeneratorFunction"),
      n(y),
      n(y, a, "Generator"),
      n(y, o, function () {
        return this;
      }),
      n(y, "toString", function () {
        return "[object Generator]";
      }),
      (e = function () {
        return {
          w: u,
          m: f,
        };
      })()
    );
  }

  function n(t, e, i, r) {
    var o = Object.defineProperty;
    try {
      o({}, "", {});
    } catch (t) {
      o = 0;
    }
    ((n = function (t, e, i, r) {
      if (e)
        o
          ? o(t, e, {
              value: i,
              enumerable: !r,
              configurable: !r,
              writable: !r,
            })
          : (t[e] = i);
      else {
        var a = function (e, i) {
          n(t, e, function (t) {
            return this._invoke(e, i, t);
          });
        };
        (a("next", 0), a("throw", 1), a("return", 2));
      }
    }),
      n(t, e, i, r));
  }

  function i(t, e) {
    var n =
      ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
    if (!n) {
      if (
        Array.isArray(t) ||
        (n = (function (t, e) {
          if (t) {
            if ("string" == typeof t) return r(t, e);
            var n = {}.toString.call(t).slice(8, -1);
            return (
              "Object" === n && t.constructor && (n = t.constructor.name),
              "Map" === n || "Set" === n
                ? Array.from(t)
                : "Arguments" === n ||
                    /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                  ? r(t, e)
                  : void 0
            );
          }
        })(t)) ||
        (e && t && "number" == typeof t.length)
      ) {
        n && (t = n);
        var i = 0,
          o = function () {};
        return {
          s: o,
          n: function () {
            return i >= t.length
              ? {
                  done: !0,
                }
              : {
                  done: !1,
                  value: t[i++],
                };
          },
          e: function (t) {
            throw t;
          },
          f: o,
        };
      }
      throw new TypeError(
        "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.",
      );
    }
    var a,
      u = !0,
      s = !1;
    return {
      s: function () {
        n = n.call(t);
      },
      n: function () {
        var t = n.next();
        return ((u = t.done), t);
      },
      e: function (t) {
        ((s = !0), (a = t));
      },
      f: function () {
        try {
          u || null == n.return || n.return();
        } finally {
          if (s) throw a;
        }
      },
    };
  }

  function r(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, i = Array(e); n < e; n++) i[n] = t[n];
    return i;
  }

  function o(t, e, n, i, r, o, a) {
    try {
      var u = t[o](a),
        s = u.value;
    } catch (t) {
      return void n(t);
    }
    u.done ? e(s) : Promise.resolve(s).then(i, r);
  }

  function a(t) {
    return function () {
      var e = this,
        n = arguments;
      return new Promise(function (i, r) {
        var a = t.apply(e, n);

        function u(t) {
          o(a, i, r, u, s, "next", t);
        }

        function s(t) {
          o(a, i, r, u, s, "throw", t);
        }
        u(void 0);
      });
    };
  }

  function u(t, e) {
    for (var n = 0; n < e.length; n++) {
      var i = e[n];
      ((i.enumerable = i.enumerable || !1),
        (i.configurable = !0),
        "value" in i && (i.writable = !0),
        Object.defineProperty(t, s(i.key), i));
    }
  }

  function s(e) {
    var n = (function (e, n) {
      if ("object" != t(e) || !e) return e;
      var i = e[Symbol.toPrimitive];
      if (void 0 !== i) {
        var r = i.call(e, n || "default");
        if ("object" != t(r)) return r;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return ("string" === n ? String : Number)(e);
    })(e, "string");
    return "symbol" == t(n) ? n : n + "";
  }
  !(function () {
    "use strict";
    if (!window.GMV_PDP_Rhude) {
      var t = (function () {
        return (
          (t = function t(e) {
            var n, i, r;
            (!(function (t, e) {
              if (!(t instanceof e))
                throw new TypeError("Cannot call a class as a function");
            })(this, t),
              (this.container = e),
              (this.productId = e.dataset.productId),
              (this.sectionId = e.dataset.sectionId));
            var o = document.querySelector("[data-product-json]");
            this.variants = o ? JSON.parse(o.textContent) : [];
            var a = document.querySelector("[data-inventory-json]");
            ((this.inventoryMap = a ? JSON.parse(a.textContent) : {}),
              (this.form = e.querySelector("[data-product-form]")),
              (this.variantIdInput = e.querySelector("[data-variant-id]")),
              (this.addToCartButton = e.querySelector("[data-add-to-cart]")),
              (this.buttonText =
                null === (n = this.addToCartButton) || void 0 === n
                  ? void 0
                  : n.querySelector("[data-button-text]")),
              (this.textAddToCart =
                (null === (i = this.addToCartButton) || void 0 === i
                  ? void 0
                  : i.dataset.textAddToCart) || "ADD TO CART"),
              (this.textSoldOut =
                (null === (r = this.addToCartButton) || void 0 === r
                  ? void 0
                  : r.dataset.textSoldOut) || "SOLD OUT"),
              (this.priceContainer = e.querySelector("[data-price-container]")),
              (this.priceElement = e.querySelector("[data-price]")),
              (this.variantOptions = e.querySelectorAll(
                "[data-variant-option]",
              )),
              (this.quantityInput = e.querySelector("[data-quantity-input]")),
              (this.quantityMinusBtn = e.querySelector(
                "[data-quantity-minus]",
              )),
              (this.quantityPlusBtn = e.querySelector("[data-quantity-plus]")),
              (this.notifyMeContainer = e.querySelector("[data-notify-me]")),
              (this.notifyEmailInput = e.querySelector("[data-notify-email]")),
              (this.notifySubmitBtn = e.querySelector("[data-notify-submit]")),
              (this.notifySuccess = e.querySelector("[data-notify-success]")),
              (this.zoomTriggers = e.querySelectorAll("[data-zoom-trigger]")),
              (this.zoomOverlay = e.querySelector("[data-zoom-overlay]")),
              (this.zoomClose = e.querySelector("[data-zoom-close]")),
              (this.zoomImages = e.querySelectorAll("[data-zoom-image]")),
              (this.accordionTriggers = e.querySelectorAll(
                "[data-accordion-trigger]",
              )),
              (this.gallerySlider = e.querySelector("[data-gallery-slider]")),
              (this.galleryPrevBtn = e.querySelector("[data-gallery-prev]")),
              (this.galleryNextBtn = e.querySelector("[data-gallery-next]")),
              (this.galleryCurrentSlide = e.querySelector(
                "[data-current-slide]",
              )),
              (this.currentSlideIndex = 0),
              (this.sizeGuideButtons = e.querySelectorAll(
                "[data-open-size-guide]",
              )),
              (this.sizeGuideOverlay = e.querySelector(
                "#size-guide-overlay-rhude",
              )),
              (this.sizeGuidePopup = e.querySelector(
                "#size-guide-popup-rhude",
              )),
              (this.sizeGuideClose = e.querySelector(
                "[data-close-size-guide]",
              )),
              (this.lowStockIndicator = e.querySelector(
                "[data-low-stock-indicator]",
              )),
              this.init());
          }),
          (n = [
            {
              key: "init",
              value: function () {
                (this.setupVariants(),
                  this.setupQuantity(),
                  this.setupForm(),
                  this.setupZoom(),
                  this.setupAccordions(),
                  this.setupNotifyMe(),
                  this.setupMobileGalleryNav(),
                  this.setupSizeGuide(),
                  this.setInitialVariant(),
                  this.updateQuantityButtons());
              },
            },
            {
              key: "setupVariants",
              value: function () {
                var t = this;
                this.variantOptions.forEach(function (e) {
                  e.addEventListener("change", function () {
                    return t.handleVariantChange();
                  });
                });
              },
            },
            {
              key: "handleVariantChange",
              value: function () {
                var t = this.getSelectedOptions(),
                  e = this.getVariantFromOptions(t);
                e && this.updateVariant(e);
              },
            },
            {
              key: "getSelectedOptions",
              value: function () {
                var t = {};
                return (
                  this.variantOptions.forEach(function (e) {
                    if (e.checked) {
                      var n = e.dataset.optionPosition;
                      t["option".concat(n)] = e.value;
                    }
                  }),
                  t
                );
              },
            },
            {
              key: "getVariantFromOptions",
              value: function (t) {
                return this.variants.find(function (e) {
                  return Object.keys(t).every(function (n) {
                    return e[n] === t[n];
                  });
                });
              },
            },
            {
              key: "updateVariant",
              value: function (t) {
                (this.variantIdInput &&
                  ((this.variantIdInput.value = t.id),
                  (this.variantIdInput.disabled = !1)),
                  this.updatePrice(t),
                  this.updateAddToCartButton(t),
                  this.updateQuantityMax(t),
                  this.updateLowStockIndicator(t),
                  this.updateURL(t),
                  this.toggleNotifyMe(!t.available));
              },
            },
            {
              key: "updatePrice",
              value: function (t) {
                var e;
                if (this.priceElement) {
                  var n = this.formatMoney(t.price);
                  this.priceElement.textContent = n;
                  this.priceElement.setAttribute("data-base-price", t.price);
                  var i =
                    null === (e = this.priceContainer) || void 0 === e
                      ? void 0
                      : e.querySelector(".gmv-pdp-rhude__price-compare");
                  i &&
                    (t.compare_at_price && t.compare_at_price > t.price
                      ? ((i.textContent = this.formatMoney(t.compare_at_price)),
                        (i.style.display = ""))
                      : (i.style.display = "none"));
                  var originalValueEl = this.priceContainer
                    ? this.priceContainer.querySelector(
                        ".gmv-pdp-rhude__price-original-value",
                      )
                    : null;
                  if (originalValueEl) {
                    originalValueEl.textContent = n;
                    if (window.setOriginalPriceValueRhude)
                      window.setOriginalPriceValueRhude(n);
                  }
                }
              },
            },
            {
              key: "updateAddToCartButton",
              value: function (t) {
                this.addToCartButton &&
                  this.buttonText &&
                  (t.available
                    ? ((this.addToCartButton.disabled = !1),
                      (this.buttonText.textContent = this.textAddToCart))
                    : ((this.addToCartButton.disabled = !0),
                      (this.buttonText.textContent = this.textSoldOut)),
                  this.updateQuantityControlsState(t.available));
              },
            },
            {
              key: "updateQuantityControlsState",
              value: function (t) {
                (this.quantityMinusBtn && (this.quantityMinusBtn.disabled = !t),
                  this.quantityPlusBtn && (this.quantityPlusBtn.disabled = !t),
                  this.quantityInput && (this.quantityInput.disabled = !t));
              },
            },
            {
              key: "updateURL",
              value: function (t) {
                if (t && window.history.replaceState) {
                  var e = new URL(window.location.href);
                  (e.searchParams.set("variant", t.id),
                    window.history.replaceState({}, "", e.toString()));
                }
              },
            },
            {
              key: "setInitialVariant",
              value: function () {
                var t = new URLSearchParams(window.location.search).get(
                  "variant",
                );
                if (t) {
                  var e = this.variants.find(function (e) {
                    return e.id == t;
                  });
                  e && (this.selectVariantOptions(e), this.updateVariant(e));
                } else {
                  var c = this.getCurrentVariant();
                  if (c) this.updateLowStockIndicator(c);
                }
              },
            },
            {
              key: "selectVariantOptions",
              value: function (t) {
                this.variantOptions.forEach(function (e) {
                  var n = e.dataset.optionPosition,
                    i = "option".concat(n);
                  t[i] === e.value && (e.checked = !0);
                });
              },
            },
            {
              key: "setupQuantity",
              value: function () {
                var t,
                  e,
                  n = this;
                var lastClickTime = 0;
                function qtyGuard() {
                  var now = Date.now();
                  if (now - lastClickTime < 300) return false;
                  lastClickTime = now;
                  return true;
                }
                this.quantityInput &&
                  (null === (t = this.quantityMinusBtn) ||
                    void 0 === t ||
                    t.addEventListener("click", function (t) {
                      t.preventDefault();
                      t.stopImmediatePropagation();
                      if (n.quantityMinusBtn.disabled || !qtyGuard()) return;
                      var e = parseInt(n.quantityInput.value) || 1;
                      e > 1 && (n.quantityInput.value = e - 1);
                      n.updateQuantityButtons();
                    }),
                  null === (e = this.quantityPlusBtn) ||
                    void 0 === e ||
                    e.addEventListener("click", function (t) {
                      t.preventDefault();
                      t.stopImmediatePropagation();
                      if (n.quantityPlusBtn.disabled || !qtyGuard()) return;
                      var e = parseInt(n.quantityInput.value) || 1;
                      e < (parseInt(n.quantityInput.max) || 999)
                        ? (n.quantityInput.value = e + 1)
                        : n.showMaxQuantityWarning();
                      n.updateQuantityButtons();
                    }));
              },
            },
            {
              key: "updateQuantityButtons",
              value: function () {
                if (this.quantityInput && !this.quantityInput.disabled) {
                  var t = parseInt(this.quantityInput.value) || 1,
                    e = parseInt(this.quantityInput.max) || 999;
                  (this.quantityMinusBtn &&
                    (this.quantityMinusBtn.disabled = t <= 1),
                    this.quantityPlusBtn &&
                      (this.quantityPlusBtn.disabled = t >= e));
                }
              },
            },
            {
              key: "showMaxQuantityWarning",
              value: function () {
                var e = parseInt(this.quantityInput.max) || 0;
                var lang =
                  window.location.pathname.indexOf("/en") === 0 ||
                  window.location.pathname.indexOf("/en/") === 0
                    ? "en"
                    : "it";
                var msg =
                  lang === "en"
                    ? "Only " +
                      e +
                      " item" +
                      (e !== 1 ? "s" : "") +
                      " available for this product"
                    : "Solo " +
                      e +
                      " pezz" +
                      (e !== 1 ? "i" : "o") +
                      " disponibil" +
                      (e !== 1 ? "i" : "e") +
                      " per questo prodotto";
                this.showToast(msg);
              },
            },
            {
              key: "showToast",
              value: function (msg) {
                var toast = document.querySelector("[data-quantity-toast]");
                if (!toast) return;
                var msgEl = toast.querySelector("[data-toast-message]");
                if (msgEl) msgEl.textContent = msg;
                toast.hidden = false;
                toast.offsetHeight;
                toast.classList.add("is-visible");
                if (this._toastTimer) clearTimeout(this._toastTimer);
                var self = this;
                this._toastTimer = setTimeout(function () {
                  toast.classList.remove("is-visible");
                  setTimeout(function () {
                    toast.hidden = true;
                  }, 300);
                }, 3000);
              },
            },
            {
              key: "updateQuantityMax",
              value: function (t) {
                if (this.quantityInput) {
                  var e = 999;
                  if (this.inventoryMap && this.inventoryMap[t.id]) {
                    var n = this.inventoryMap[t.id];
                    n > 0
                      ? (e = n)
                      : 0 !== n || t.available
                        ? 0 === n && t.available && (e = 999)
                        : (e = 0);
                  }
                  ((this.quantityInput.max = e),
                    (this.quantityInput.value = 1),
                    this.updateQuantityButtons());
                }
              },
            },
            {
              key: "updateLowStockIndicator",
              value: function (t) {
                if (this.lowStockIndicator) {
                  var qty = 0;

                  // Ambil stok dari inventoryMap (JSON di bawah section)
                  if (this.inventoryMap && this.inventoryMap[t.id] !== void 0) {
                    qty = this.inventoryMap[t.id];
                  } else if (typeof t.inventory_quantity === "number") {
                    qty = t.inventory_quantity;
                  }

                  // DEBUG: lihat kondisi stok di console
                  console.log(
                    "[GMV Rhude] Variant ID:",
                    t.id,
                    "Title:",
                    t.title,
                    "Qty:",
                    qty,
                    "Available:",
                    t.available,
                  );

                  // Logic tampil / sembunyi tulisan "Low Stock"
                  if (qty > 0 && qty < 3) {
                    this.lowStockIndicator.style.display = "inline";
                  } else {
                    this.lowStockIndicator.style.display = "none";
                  }
                }
              },
            },
            {
              key: "setupForm",
              value: function () {
                var self = this;
                this._addToCartBusy = false;
                if (this.form) {
                  this.form.addEventListener(
                    "submit",
                    function (e) {
                      e.preventDefault();
                      e.stopImmediatePropagation();
                      if (self._addToCartBusy) return;
                      self.handleAddToCart();
                    },
                    true,
                  );
                }
              },
            },
            {
              key: "handleAddToCart",
              value: function () {
                var self = this;
                if (!this.variantIdInput || this.variantIdInput.disabled)
                  return;
                var variant = this.getCurrentVariant();
                if (!variant) return;
                this.variantIdInput.value = variant.id;
                this.setButtonLoading(true);
                this._addToCartBusy = true;

                var cartDrawer = document.querySelector("cart-drawer");
                var formData = new FormData(this.form);

                var keysToRemove = [];
                var keyIter = formData.keys();
                var keyResult = keyIter.next();
                while (!keyResult.done) {
                  var k = keyResult.value;
                  if (
                    k.startsWith("options[") ||
                    k === "product-id" ||
                    k === "section-id"
                  )
                    keysToRemove.push(k);
                  keyResult = keyIter.next();
                }
                keysToRemove.forEach(function (k) {
                  formData.delete(k);
                });

                if (!formData.get("id")) {
                  this.setButtonLoading(false);
                  this._addToCartBusy = false;
                  return;
                }

                if (cartDrawer) {
                  formData.append("sections", "gmv-cart-drawer");
                  formData.append("sections_url", window.location.pathname);
                  if (cartDrawer.setActiveElement)
                    cartDrawer.setActiveElement(document.activeElement);
                }

                var addUrl = "/cart/add.js";
                if (
                  window.Shopify &&
                  window.Shopify.routes &&
                  window.Shopify.routes.root
                ) {
                  addUrl = window.Shopify.routes.root + "cart/add.js";
                } else if (window.routes && window.routes.cart_add_url) {
                  addUrl = window.routes.cart_add_url;
                }

                fetch(addUrl, {
                  method: "POST",
                  headers: { "X-Requested-With": "XMLHttpRequest" },
                  body: formData,
                })
                  .then(function (response) {
                    if (!response.ok) {
                      return response
                        .json()
                        .catch(function () {
                          return { message: response.statusText };
                        })
                        .then(function (err) {
                          throw new Error(
                            err.description ||
                              err.message ||
                              "Failed to add to cart",
                          );
                        });
                    }
                    return response.json();
                  })
                  .then(function (data) {
                    if (data.status)
                      throw new Error(
                        data.description || "Failed to add to cart",
                      );
                    document.dispatchEvent(
                      new CustomEvent("cart:item-added", {
                        detail: data,
                        bubbles: true,
                      }),
                    );
                    document.dispatchEvent(
                      new CustomEvent("cart:updated", {
                        detail: data,
                        bubbles: true,
                      }),
                    );
                    if (
                      cartDrawer &&
                      typeof cartDrawer.renderContents === "function"
                    ) {
                      try {
                        cartDrawer.renderContents(data);
                      } catch (e) {
                        console.error("Cart drawer render error:", e);
                      }
                    } else {
                      window.location.href =
                        (window.routes && window.routes.cart_url) || "/cart";
                    }
                  })
                  .catch(function (err) {
                    console.error("Add to cart error:", err);
                    self.showAddToCartError(err.message || "Error");
                  })
                  .finally(function () {
                    self.setButtonLoading(false);
                    self._addToCartBusy = false;
                  });
              },
            },
            {
              key: "setButtonLoading",
              value: function (t) {
                if (this.addToCartButton && this.buttonText)
                  if (t)
                    ((this.addToCartButton.disabled = !0),
                      (this.buttonText.textContent = "ADDING..."));
                  else {
                    var e = this.getCurrentVariant();
                    this.updateAddToCartButton(
                      e || {
                        available: !1,
                      },
                    );
                  }
              },
            },
            {
              key: "getCurrentVariant",
              value: function () {
                var t = this.getSelectedOptions();
                return this.getVariantFromOptions(t);
              },
            },
            {
              key: "showAddToCartSuccess",
              value: function () {
                var t = this;
                if (this.buttonText) {
                  var e = this.buttonText.textContent;
                  ((this.buttonText.textContent = "ADDED!"),
                    setTimeout(function () {
                      t.buttonText.textContent = e;
                    }, 2e3));
                }
              },
            },
            {
              key: "showAddToCartError",
              value: function (t) {
                var lang =
                  window.location.pathname.indexOf("/en") === 0 ||
                  window.location.pathname.indexOf("/en/") === 0
                    ? "en"
                    : "it";
                var msg =
                  t ||
                  (lang === "en"
                    ? "Could not add to cart. Please try again."
                    : "Impossibile aggiungere al carrello. Riprova.");
                this.showToast(msg);
              },
            },
            {
              key: "setupNotifyMe",
              value: function () {
                var t = this;
                this.notifySubmitBtn &&
                  this.notifySubmitBtn.addEventListener("click", function () {
                    t.handleNotifyMe();
                  });
              },
            },
            {
              key: "toggleNotifyMe",
              value: function (t) {
                this.notifyMeContainer &&
                  (t
                    ? ((this.notifyMeContainer.hidden = !1),
                      (this.notifySuccess.hidden = !0))
                    : (this.notifyMeContainer.hidden = !0));
              },
            },
            {
              key: "handleNotifyMe",
              value:
                ((o = a(
                  e().m(function t() {
                    var n,
                      i,
                      r,
                      o,
                      a = this;
                    return e().w(
                      function (t) {
                        for (;;)
                          switch (t.n) {
                            case 0:
                              if (this.notifyEmailInput) {
                                t.n = 1;
                                break;
                              }
                              return t.a(2);
                            case 1:
                              if (
                                (n = this.notifyEmailInput.value.trim()) &&
                                this.isValidEmail(n)
                              ) {
                                t.n = 2;
                                break;
                              }
                              return (
                                alert("Please enter a valid email address"),
                                t.a(2)
                              );
                            case 2:
                              if ((i = this.getCurrentVariant())) {
                                t.n = 3;
                                break;
                              }
                              return t.a(2);
                            case 3:
                              return (
                                (r = window.location.pathname.split("/").pop()),
                                (o = "notify: "
                                  .concat(r, " | ")
                                  .concat(i.title)),
                                (t.p = 4),
                                (t.n = 5),
                                fetch("/contact", {
                                  method: "POST",
                                  headers: {
                                    "Content-Type":
                                      "application/x-www-form-urlencoded",
                                  },
                                  body: new URLSearchParams({
                                    form_type: "contact",
                                    utf8: "✓",
                                    "contact[email]": n,
                                    "contact[body]": o,
                                  }),
                                })
                              );
                            case 5:
                              (t.v.ok &&
                                ((this.notifySuccess.hidden = !1),
                                (this.notifyEmailInput.value = ""),
                                setTimeout(function () {
                                  a.notifySuccess.hidden = !0;
                                }, 5e3)),
                                (t.n = 7));
                              break;
                            case 6:
                              ((t.p = 6),
                                t.v,
                                alert(
                                  "Sorry, there was an error. Please try again.",
                                ));
                            case 7:
                              return t.a(2);
                          }
                      },
                      t,
                      this,
                      [[4, 6]],
                    );
                  }),
                )),
                function () {
                  return o.apply(this, arguments);
                }),
            },
            {
              key: "isValidEmail",
              value: function (t) {
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(t);
              },
            },
            {
              key: "setupZoom",
              value: function () {
                var t,
                  e = this;
                this.zoomTriggers.length &&
                  this.zoomOverlay &&
                  (this.zoomTriggers.forEach(function (t, n) {
                    t.addEventListener("click", function (n) {
                      var i = t.closest(".gmv-pdp-rhude__gallery-cell");
                      if (i) {
                        var r = Array.from(
                          e.container.querySelectorAll(
                            ".gmv-pdp-rhude__gallery-cell",
                          ),
                        ).indexOf(i);
                        e.openZoom(r >= 0 ? r : 0);
                      } else e.openZoom(0);
                    });
                  }),
                  null === (t = this.zoomClose) ||
                    void 0 === t ||
                    t.addEventListener("click", function () {
                      return e.closeZoom();
                    }),
                  this.zoomOverlay.addEventListener("click", function (t) {
                    t.target === e.zoomOverlay && e.closeZoom();
                  }),
                  document.addEventListener("keydown", function (t) {
                    e.zoomOverlay.hidden ||
                      ("Escape" === t.key && e.closeZoom());
                  }));
              },
            },
            {
              key: "openZoom",
              value: function () {
                var t = this,
                  e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : 0;
                this.zoomOverlay &&
                  ((this.zoomOverlay.hidden = !1),
                  this.zoomImages.forEach(function (t) {
                    t.style.display = "block";
                  }),
                  (document.body.style.overflow = "hidden"),
                  this.container.querySelector(
                    ".gmv-pdp-rhude__zoom-content",
                  ) &&
                    this.zoomImages[e] &&
                    setTimeout(function () {
                      var n = t.zoomImages[e];
                      n &&
                        n.scrollIntoView({
                          behavior: "instant",
                          block: "start",
                        });
                    }, 50));
              },
            },
            {
              key: "closeZoom",
              value: function () {
                this.zoomOverlay &&
                  ((this.zoomOverlay.hidden = !0),
                  (document.body.style.overflow = ""));
              },
            },
            {
              key: "setupAccordions",
              value: function () {
                // Accordion clicks are handled by document-level delegation below
              },
            },
            {
              key: "toggleAccordion",
              value: function (t) {
                var e = t.nextElementSibling;
                if (!e) return;
                var n = t.getAttribute("aria-expanded") === "true";
                t.setAttribute("aria-expanded", String(!n));
                if (n) {
                  e.setAttribute("hidden", "");
                } else {
                  e.removeAttribute("hidden");
                }
              },
            },
            {
              key: "setupSizeGuide",
              value: function () {
                var t = this;
                this.sizeGuideButtons &&
                  0 !== this.sizeGuideButtons.length &&
                  this.sizeGuideOverlay &&
                  this.sizeGuidePopup &&
                  (this.sizeGuideButtons.forEach(function (e) {
                    e.addEventListener("click", function () {
                      return t.openSizeGuide();
                    });
                  }),
                  this.sizeGuideClose &&
                    this.sizeGuideClose.addEventListener("click", function () {
                      return t.closeSizeGuide();
                    }),
                  this.sizeGuideOverlay.addEventListener("click", function () {
                    return t.closeSizeGuide();
                  }),
                  document.addEventListener("keydown", function (e) {
                    "Escape" !== e.key ||
                      t.sizeGuidePopup.classList.contains("hidden") ||
                      t.closeSizeGuide();
                  }));
              },
            },
            {
              key: "openSizeGuide",
              value: function () {
                var t = this;
                (this.sizeGuideOverlay.classList.remove("hidden"),
                  this.sizeGuidePopup.classList.remove("hidden"),
                  this.sizeGuideOverlay.offsetHeight,
                  requestAnimationFrame(function () {
                    (t.sizeGuideOverlay.classList.add("show"),
                      t.sizeGuidePopup.classList.add("show"));
                  }),
                  (document.body.style.overflow = "hidden"));
              },
            },
            {
              key: "closeSizeGuide",
              value: function () {
                var t = this;
                (this.sizeGuideOverlay.classList.remove("show"),
                  this.sizeGuidePopup.classList.remove("show"),
                  setTimeout(function () {
                    (t.sizeGuideOverlay.classList.add("hidden"),
                      t.sizeGuidePopup.classList.add("hidden"));
                  }, 300),
                  (document.body.style.overflow = ""));
              },
            },
            {
              key: "formatMoney",
              value: function (t) {
                var e;
                if ("undefined" != typeof Shopify && Shopify.formatMoney)
                  return Shopify.formatMoney(
                    t,
                    (null === (e = window.theme) || void 0 === e
                      ? void 0
                      : e.moneyFormat) || "${{amount}}",
                  );
                var n = (t / 100).toFixed(2);
                return "$".concat(n);
              },
            },
            {
              key: "setupMobileGalleryNav",
              value: function () {
                var t = this;
                if (
                  this.gallerySlider &&
                  this.galleryPrevBtn &&
                  this.galleryNextBtn
                ) {
                  var e = this.gallerySlider.querySelectorAll(
                      ".gmv-pdp-rhude__gallery-cell",
                    ),
                    n = e.length;
                  if (n <= 1) {
                    var i = this.container.querySelector("[data-gallery-nav]");
                    i && (i.style.display = "none");
                  } else
                    (this.gallerySlider.addEventListener("scroll", function () {
                      var n = t.gallerySlider.scrollLeft,
                        i = t.gallerySlider.offsetWidth || 1,
                        r = Math.round(n / i);
                      r !== t.currentSlideIndex &&
                        ((t.currentSlideIndex = r),
                        t.updateGalleryCounter(),
                        t.updateGalleryButtons());
                    }),
                      this.galleryPrevBtn.addEventListener(
                        "click",
                        function () {
                          t.currentSlideIndex > 0 &&
                            (t.currentSlideIndex--,
                            t.scrollToSlide(t.currentSlideIndex));
                        },
                      ),
                      this.galleryNextBtn.addEventListener(
                        "click",
                        function () {
                          t.currentSlideIndex < n - 1 &&
                            (t.currentSlideIndex++,
                            t.scrollToSlide(t.currentSlideIndex));
                        },
                      ),
                      this.updateGalleryCounter(),
                      this.updateGalleryButtons());
                }
              },
            },
            {
              key: "scrollToSlide",
              value: function (t) {
                var e = this.gallerySlider.querySelector(
                  ".gmv-pdp-rhude__gallery-cell",
                );
                if (!e) return;
                var slideWidth = e.offsetWidth;
                this.gallerySlider.scrollTo({
                  left: t * slideWidth,
                  behavior: "smooth",
                });
              },
            },
            {
              key: "updateGalleryCounter",
              value: function () {
                this.galleryCurrentSlide &&
                  (this.galleryCurrentSlide.textContent =
                    this.currentSlideIndex + 1);
              },
            },
            {
              key: "updateGalleryButtons",
              value: function () {
                var t = this.gallerySlider.querySelectorAll(
                  ".gmv-pdp-rhude__gallery-cell",
                ).length;
                (this.galleryPrevBtn &&
                  (this.galleryPrevBtn.disabled = 0 === this.currentSlideIndex),
                  this.galleryNextBtn &&
                    (this.galleryNextBtn.disabled =
                      this.currentSlideIndex === t - 1));
              },
            },
          ]),
          n && u(t.prototype, n),
          r && u(t, r),
          Object.defineProperty(t, "prototype", {
            writable: !1,
          }),
          t
        );
        var t, n, r, o, s;
      })();
      ("loading" === document.readyState
        ? document.addEventListener("DOMContentLoaded", n)
        : n(),
        "undefined" != typeof Shopify &&
          document.addEventListener("shopify:section:load", n),
        (window.GMV_PDP_Rhude = t));
    }

    function n() {
      document.querySelectorAll(".gmv-pdp-rhude").forEach(function (e) {
        e.dataset.initialized || (new t(e), (e.dataset.initialized = "true"));
      });
    }

    function initStickyInfo() {
      if (window.innerWidth <= 768) return;

      var infoSticky = document.querySelector(".gmv-pdp-rhude__info-sticky");
      var infoParent = document.querySelector(".gmv-pdp-rhude__info");
      var gallery = document.querySelector(".gmv-pdp-rhude__gallery");

      if (!infoSticky || !infoParent || !gallery) return;

      var stickyTop = 87;
      var stickyWidth = 0;
      var stickyLeft = 0;
      var originalOffsetTop = 0;

      function calculatePositions() {
        var parentRect = infoParent.getBoundingClientRect();
        stickyWidth = parentRect.width;
        stickyLeft = parentRect.left + window.pageXOffset;
        originalOffsetTop = infoParent.offsetTop;
      }

      function checkSticky() {
        if (window.innerWidth <= 768) {
          infoSticky.classList.remove("is-stuck", "is-bottom");
          infoSticky.style.width = "";
          infoSticky.style.left = "";
          infoSticky.style.top = "";
          infoSticky.style.position = "";
          return;
        }

        calculatePositions();

        var scrollTop =
          window.pageYOffset || document.documentElement.scrollTop;
        var infoHeight = infoSticky.offsetHeight;
        var galleryBottom = gallery.offsetTop + gallery.offsetHeight;
        var panelBottom = scrollTop + stickyTop + infoHeight;

        if (scrollTop + stickyTop >= originalOffsetTop) {
          if (panelBottom <= galleryBottom) {
            infoSticky.classList.add("is-stuck");
            infoSticky.classList.remove("is-bottom");
            infoSticky.style.position = "fixed";
            infoSticky.style.width = stickyWidth + "px";
            infoSticky.style.left = stickyLeft + "px";
            infoSticky.style.top = stickyTop + "px";
          } else {
            infoSticky.classList.remove("is-stuck");
            infoSticky.classList.add("is-bottom");
            var maxTop = galleryBottom - infoHeight - originalOffsetTop;
            infoSticky.style.position = "absolute";
            infoSticky.style.width = "";
            infoSticky.style.left = "";
            infoSticky.style.top = maxTop + "px";
          }
        } else {
          infoSticky.classList.remove("is-stuck", "is-bottom");
          infoSticky.style.position = "";
          infoSticky.style.width = "";
          infoSticky.style.left = "";
          infoSticky.style.top = "";
        }
      }

      var scrollTimeout;
      function handleScroll() {
        if (scrollTimeout) {
          window.cancelAnimationFrame(scrollTimeout);
        }
        scrollTimeout = window.requestAnimationFrame(checkSticky);
      }

      window.addEventListener("scroll", handleScroll, { passive: true });
      window.addEventListener("resize", function () {
        calculatePositions();
        checkSticky();
      });

      calculatePositions();
      checkSticky();
    }

    if ("loading" === document.readyState) {
      document.addEventListener("DOMContentLoaded", function () {
        n();
        initStickyInfo();
      });
    } else {
      n();
      initStickyInfo();
    }
  })();

  // Accordion: single document-level delegation, works regardless of class init order
  document.addEventListener("click", function (ev) {
    var btn = ev.target.closest("[data-accordion-trigger]");
    if (!btn) return;
    var content = btn.nextElementSibling;
    if (!content) return;
    var isExpanded = btn.getAttribute("aria-expanded") === "true";
    btn.setAttribute("aria-expanded", String(!isExpanded));
    if (isExpanded) {
      content.setAttribute("hidden", "");
    } else {
      content.removeAttribute("hidden");
    }
  });

  ((window.checkAndToggleOriginalPriceRhude = function () {
    var e = document.querySelector(".gmv-pdp-rhude [data-price]"),
      t = document.querySelector(".gmv-pdp-rhude [data-original-price]"),
      c = document.querySelector(".gmv-pdp-rhude [data-price-container]");
    if (e && t) {
      var r = e.getAttribute("data-currency") || "",
        s = c ? c.getAttribute("data-shop-currency") || "" : r;
      if (s && r) {
        r !== s ? (t.style.display = "flex") : (t.style.display = "none");
      } else {
        var n = e.textContent.trim(),
          o = n.replace(/[\d.,\s]/g, "").trim(),
          a =
            {
              EUR: "€",
              USD: "$",
              GBP: "£",
              JPY: "¥",
              CAD: "CA$",
              AUD: "A$",
              IDR: "Rp",
            }[r] || "€";
        o !== a ? (t.style.display = "flex") : (t.style.display = "none");
      }
    }
  }),
    (window.openConversionModalRhude = function () {
      var e = document.getElementById("conversion-modal-rhude");
      e &&
        (e.classList.add("active"),
        (e.style.display = "flex"),
        (document.body.style.overflow = "hidden"));
    }),
    (window.closeConversionModalRhude = function () {
      var e = document.getElementById("conversion-modal-rhude");
      e &&
        (e.classList.remove("active"),
        (e.style.display = "none"),
        (document.body.style.overflow = ""));
    }),
    window.addEventListener("click", function (e) {
      "conversion-modal-rhude" === e.target.id &&
        window.closeConversionModalRhude();
    }),
    "loading" === document.readyState
      ? document.addEventListener("DOMContentLoaded", function () {
          (setTimeout(window.checkAndToggleOriginalPriceRhude, 100),
            setTimeout(window.checkAndToggleOriginalPriceRhude, 500),
            setTimeout(window.checkAndToggleOriginalPriceRhude, 1e3));
        })
      : (setTimeout(window.checkAndToggleOriginalPriceRhude, 100),
        setTimeout(window.checkAndToggleOriginalPriceRhude, 500),
        setTimeout(window.checkAndToggleOriginalPriceRhude, 1e3)));
  var originalPriceValueGlobal = document.querySelector(
    ".gmv-pdp-rhude__price-original-value",
  );
  if (originalPriceValueGlobal) {
    var originalTextGlobal = originalPriceValueGlobal.textContent,
      originalPriceObserverGlobal = new MutationObserver(function () {
        var e = originalPriceValueGlobal.textContent;
        e !== originalTextGlobal &&
          originalTextGlobal &&
          (originalPriceValueGlobal.textContent = originalTextGlobal);
      });
    (originalPriceObserverGlobal.observe(originalPriceValueGlobal, {
      childList: !0,
      subtree: !0,
      characterData: !0,
    }),
      (window.setOriginalPriceValueRhude = function (e) {
        ((originalTextGlobal = e), (originalPriceValueGlobal.textContent = e));
      }));
  }
})();
